import React, { useState, useEffect } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Input,
  Label
} from "reactstrap";
import { postDataAPI } from "../../helpers/phpbackend_helper";
import { useEditor, EditorContent } from "@tiptap/react";
import StarterKit from "@tiptap/starter-kit";

const EditFlashcardModal = ({ isOpen, toggle, card, onSuccess }) => {
  const [frontText, setFrontText] = useState("");
  const [script, setScript] = useState(card.format_coching_script || "");
  const [saving, setSaving] = useState(false);

   const normalizeScriptToHTML = (raw = "") => {
    return raw
        ?.replace(/\\r\\n|\\n|\\r/g, "")
        ?.replace(/\\'/g, "'")
        ?.replace(/\\"/g, '"');
    };



  const editor = useEditor({
    extensions: [StarterKit],
    content: "",
    onUpdate({ editor }) {
        setScript(editor.getHTML());
    }
    });


  useEffect(() => {
    if (card && editor) {
        setFrontText(`${card.item_name} - ${card.course_name}`);

        const html = normalizeScriptToHTML(card.format_coching_script || "");
        editor.commands.setContent(html);
        setScript(html);
    }
    }, [card, editor]);


  const handleSave = () => {
    if (!script.trim()) {
      alert("Coaching script is required");
      return;
    }
    console.log(card);
    
    setSaving(true);

    postDataAPI({
      serviceName: "item_data",
      op: "create_update_flash_card",
      item_id: card.item_id,
      coching_script: script,
      flash_card_id: card.flash_id,
      dishName: frontText
    })
      .then((res) => {
        if (res.status === "ok") {
          onSuccess?.();
          toggle();
        } else {
          alert(res.message || "Failed to update flashcard");
        }
      })
      .finally(() => setSaving(false));
  };

  if (!card) return null;

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered size="md">
      <ModalHeader toggle={toggle}>Edit Flashcard</ModalHeader>

      <ModalBody>
        <Label>Front (Dish Name & Category)</Label>
        <Input value={frontText} disabled className="mb-3" />

        <Label>Back (Coaching Script)</Label>
        {/* <Input
          type="textarea"
          rows="8"
          value={script}
          onChange={(e) => setScript(e.target.value)}
        /> */}
        <EditorContent
            editor={editor}
            className="border rounded p-2"
            style={{ minHeight: 150 }}
            />
      </ModalBody>

      <ModalFooter>
        <Button outline onClick={toggle}>
          Cancel
        </Button>
        <Button color="primary" onClick={handleSave} disabled={saving}>
          {saving ? "Saving..." : "Save Changes"}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default EditFlashcardModal;
